export enum MasterDataFileStatus {
  Started = 'STARTED',
  Failed = 'FAILED',
  Finished = 'FINISHED',
}
